:host {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;

  orama-input {
    @media (--md-max) {
      padding: 0 var(--spacing-l, $spacing-l);
    }
  }

  @media (--md-max) {
    padding: var(--spacing-s, $spacing-s) 0;
  }
}

.result-wrapper {
  flex-grow: 1;
  overflow-y: auto;
  padding: 0 var(--spacing-l, $spacing-l);

  // TODO: check scroll styles
  // Maybe move somewhere else to reuse in some somponents, but not globally
  &::-webkit-scrollbar {
    width: 0.3em;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    // TODO: Should it be a variable?
    background-color: #b2b2b285;
    border-radius: var(--border-radius-l, $radius-l);
  }

  @media (--md-min) {
    padding: 0 var(--spacing-m, $spacing-m);
  }
}

.search-form {
  display: flex;
  flex-direction: column;
}
